package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_07_21_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-07-21")
@Composable
public fun Log_2023_07_21(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Battle with the Aboleth",
        ogTitle = "Battle with the Aboleth",
        date = LocalDate(2_023, 7, 21),
        ogDescription = "The heroes face the dread Aboleth Flar’Melkhis in the river, narrowly escaping its charms and mind-virus.",
        ogImage = "ai/2023-07-21.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
        Log_2023_07_21_Day_1()
    }
}
